import { useStoreActions } from '~/contexts';
import { useMutationState } from '../useMutationState';
export const useAcceptNotificationRewrite = ()=>{
    const { api } = useStoreActions();
    const { mutateAsync, isPending } = useMutationState({
        mutationFn: async (conversationId)=>api.notificationRewrite.acceptRewrite(conversationId),
        withPageLoader: false
    });
    return {
        acceptNotificationRewrite: mutateAsync,
        isLoading: isPending
    };
};
